/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".fa[_ngcontent-%COMP%]{vertical-align:middle}"];
export { styles as styles };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/loader/loader.component.scss.shim.ngstyle.js.pre-build-optimizer.js